"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author arsen.avagumyan on 1/15/2018.
 */
var RuleCategory = /** @class */ (function () {
    function RuleCategory(category, participatesInReport) {
        this.category = category;
        this.participatesInReport = participatesInReport;
    }
    return RuleCategory;
}());
exports.RuleCategory = RuleCategory;
//# sourceMappingURL=indicator-rule-category.model.js.map